/**
 * Value Mapper — pure lookup over a named dictionary (rani pink → Pink).
 * Never throws. Returns undefined on a miss so callers can decide passthrough
 * vs default.
 */
import type { LookupDictionary } from "./types";

function norm(s: string, caseInsensitive: boolean, trim: boolean): string {
  let v = s ?? "";
  // Treat underscores, hyphens, and runs of whitespace as one separator so
  // "rani_pink", "rani-pink", and "Rani  Pink" all match the same entry.
  v = v.replace(/[\s_-]+/g, " ");
  if (trim) v = v.trim();
  if (caseInsensitive) v = v.toLowerCase();
  return v;
}

export function lookupMapping(
  value: string,
  dict: LookupDictionary | undefined,
): string | undefined {
  if (!dict || !Array.isArray(dict.entries)) return undefined;
  const ci = dict.caseInsensitive !== false; // default true
  const tr = dict.trim !== false; // default true
  const needle = norm(value, ci, tr);
  for (const e of dict.entries) {
    if (norm(e.from, ci, tr) === needle) return e.to;
  }
  return undefined;
}
